import { useEffect, useReducer } from 'react';
import {
  type GeolocationResponse,
  geolocation,
} from '../../services/geolocation/geolocation';

enum ActionTypes {
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_ERROR = 'FETCH_ERROR',
}

interface LocationState {
  location: GeolocationResponse | null;
  loading: boolean;
  error: Error | null;
}

interface FetchSuccessAction {
  type: ActionTypes.FETCH_SUCCESS;
  data: GeolocationResponse;
}

interface FetchErrorAction {
  type: ActionTypes.FETCH_ERROR;
  error: Error;
}

type LocationAction = FetchSuccessAction | FetchErrorAction;

function locationReducer(
  state: LocationState,
  action: LocationAction,
): LocationState {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      return {
        location: action.data,
        loading: false,
        error: null,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export function useLocation() {
  const [state, dispatch] = useReducer(locationReducer, {
    location: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    async function fetchLocation() {
      try {
        const data = await geolocation.fetch();
        dispatch({ type: ActionTypes.FETCH_SUCCESS, data });
      } catch (error) {
        dispatch({ type: ActionTypes.FETCH_ERROR, error });
      }
    }

    fetchLocation();
  }, []);

  return state;
}
